import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { updateAssetTypeSaga } from "src/store/asset-types/saga";
import { AssetTypeDetailDto } from "src/store/asset-types/type";
import * as Yup from "yup";
import { SectorDto } from "src/store/system/type";
import { getSectors } from "src/store/system/saga";

const AssetTypesEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: AssetTypeDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [sectors, setSectors] = useState<SectorDto[]>([]);
  useEffect(() => {
    open &&
      dispatch(
        getSectors({
          payload: {
            onSuccess: (m, p) => setSectors(p),
            onError: () => {},
          },
        })
      );
  }, [dispatch, open]);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("AssetType.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          Name: data.Name,
          SectorId: data.SectorId,
          Translates: data.Translates,
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),
          SectorId: Yup.string().required(t("Validation.Required").toString()),
        })}
        onSubmit={(values) => {
          dispatch(
            updateAssetTypeSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("AssetType.Name").toString(),
          },
        ]}
        inputs={[
          {
            field: "SectorId",
            label: t("AssetType.Sector").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "Id",
              options: sectors,
            },
          },
        ]}
      />
    </React.Fragment>
  );
};
export default AssetTypesEditForm;
